import { ReactElement } from 'react';
import { AdminPermission } from '@localstack/types';
import { buildRoute } from '@localstack/services';

import {
  ChevronLeft,
  Apartment,
  PieChart,
  Group,
  IntegrationInstructions,
  Podcasts,
  ToggleOn as FeatureFlagsIcon,
  SupervisorAccount as AdminUsersIcon,
} from '@mui/icons-material';

import { useAuthProvider } from '~/hooks/useAuthProvider';
import { AppRoute } from '~/config';

import { NavbarContainer, NavbarSection, SectionItem, SectionHeader } from './shared';
import { NavbarCloseButton } from './NavbarCloseButton';

export const AdminNavbar = (): ReactElement => {
  const { can } = useAuthProvider();

  return (
    <NavbarContainer>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <SectionItem label="Back to app" icon={ChevronLeft} to={AppRoute.GETTING_STARTED} />
        <NavbarCloseButton />
      </div>

      <NavbarSection data-name="administration sub navigation">
        <SectionHeader>Administration</SectionHeader>
        <SectionItem label="Overview" to={buildRoute(AppRoute.ADMIN_HOME)} end icon={PieChart}></SectionItem>
        {can(AdminPermission.USERS_READ) && (
          <SectionItem label="Users" to={buildRoute(AppRoute.ADMIN_ACCOUNTS)} icon={Group}></SectionItem>
        )}
        {can(AdminPermission.WORKSPACES_READ) && (
          <SectionItem label="Workspaces" to={buildRoute(AppRoute.ADMIN_ORGANIZATIONS)} icon={Apartment}></SectionItem>
        )}
        {can(AdminPermission.EXTENSIONS_READ) && (
          <SectionItem
            label="Extensions"
            to={buildRoute(AppRoute.ADMIN_EXTENSIONS)}
            icon={IntegrationInstructions}
          ></SectionItem>
        )}
        {can(AdminPermission.ANNOUNCEMENTS) && (
          <SectionItem label="Announcements" to={buildRoute(AppRoute.ADMIN_ANNOUNCEMENT)} icon={Podcasts}></SectionItem>
        )}
        {can(AdminPermission.FEATURE_FLAGS_READ) && (
          <SectionItem
            label="Feature Flags"
            to={buildRoute(AppRoute.ADMIN_FEATURE_FLAGS)}
            icon={FeatureFlagsIcon}
          ></SectionItem>
        )}
        {can(AdminPermission.SUPER_ADMIN) && (
          <SectionItem
            label="Manage Access"
            to={buildRoute(AppRoute.ADMIN_ADMIN_USERS)}
            icon={AdminUsersIcon}
            disabled={!can(AdminPermission.SUPER_ADMIN)}
          ></SectionItem>
        )}
      </NavbarSection>
    </NavbarContainer>
  );
};
